import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import RawDataView from "@/features/K1Dashboard/views/RawDataView";

export default function K1RawData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Raw Data");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <RawDataView />
      </main>
    </K1DashboardProvider>
  );
}
